const locales = ['en', 'fr']

export default locales
  .map(x => [x, require(`./translations/${x}.json`)])
  .reduce((acc, [name, module]) => Object.assign(acc, { [name]: module }), {})
